import React from 'react';
import LeftSection from './LeftSection';
import RightSection from './RightSection';

const LifePoints = ({ setSelectedOption, closeProfileModelHandler }) => {
  return (
    <div className='flex items-start gap-[4px] w-full h-full'>
      <div className='overflow-y-scroll h-[100%] max-h-[98%] w-[23%] rounded-[32px]' style={{ background: `linear-gradient(180deg, rgba(0, 235, 220, 0.50) 0%, rgba(0, 235, 220, 0.00) 100%), rgba(250, 250, 250, 0.20)` }}>
        <LeftSection
          setSelectedOption={setSelectedOption}
          closeProfileModelHandler={closeProfileModelHandler}
        />
      </div>
      <div className='overflow-y-scroll h-[100%] max-h-[98%] w-[77%] rounded-[32px] bg-[#EFEFEF] [box-shadow:0px_4px_4px_0px_rgba(0,_0,_0,_0.25)] backdrop-filter backdrop-blur-3xl'>
        <RightSection />
      </div>
    </div>
  )
}

export default LifePoints